import { Delivery, Discount, GuestCheckoutDiscount, Order, OrderItem } from '../models';

export class OrderInfoBuilder {
  private orderInfo: Order;

  constructor() {
    this.orderInfo = new Order();
  }

  public setOrderID(value: number): OrderInfoBuilder {
    this.orderInfo.orderID = value;
    return this;
  }

  public setAccountID(value: number): OrderInfoBuilder {
    this.orderInfo.accountID = value;
    return this;
  }

  public setLocationID(value: string): OrderInfoBuilder {
    this.orderInfo.locationID = value;
    return this;
  }

  public setPeriodID(value: number): OrderInfoBuilder {
    this.orderInfo.periodID = value;
    return this;
  }

  public setTimeslotStart(value: string): OrderInfoBuilder {
    this.orderInfo.timeslotStart = value;
    return this;
  }

  public setTimeslotEnd(value: string): OrderInfoBuilder {
    this.orderInfo.timeslotEnd = value;
    return this;
  }

  public setNotes(value: string): OrderInfoBuilder {
    this.orderInfo.notes = value;
    return this;
  }

  public setSubTotal(value: number): OrderInfoBuilder {
    this.orderInfo.subTotal = value;
    return this;
  }

  public setTotal(value: number): OrderInfoBuilder {
    this.orderInfo.total = value;
    return this;
  }

  public setItems(value: OrderItem[]): OrderInfoBuilder {
    this.orderInfo.items = value;
    return this;
  }

  public setDelivery(value: Delivery): OrderInfoBuilder {
    this.orderInfo.delivery = value;
    return this;
  }

  public setDiscounts(value: Discount[] | GuestCheckoutDiscount): OrderInfoBuilder {
    this.orderInfo.discounts = value ? value : [];
    return this;
  }

  public setFirstName(value: string): OrderInfoBuilder {
    this.orderInfo.firstName = value;
    return this;
  }

  public setLastName(value: string): OrderInfoBuilder {
    this.orderInfo.lastName = value;
    return this;
  }

  public setEmail(value: string): OrderInfoBuilder {
    this.orderInfo.email = value;
    return this;
  }

  public setPhoneNumber(value: string): OrderInfoBuilder {
    this.orderInfo.phoneNumber = value;
    return this;
  }

  public setStatus(value: string): OrderInfoBuilder {
    this.orderInfo.status = value;
    return this;
  }

  public build(): Order {
    return this.orderInfo;
  }
}
